// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1E13r","additionalInfo":"AgreementModal_additionalInfo__2hanL"};